import { HOME_PREVIEW_PATH, NAV_TYPE } from '@/utils/constants';
import { EPlatform } from '@/utils/enums/platform-enum';
import type { GlobalInitNavMode } from '@/utils/map-global-init-data';

export const PC_NAV_DRAFT_PREVIEW_HEADER = 'X-PC-Nav-Draft-Preview';
export const NAV_DRAFT_PREVIEW_MODE_HEADER = 'X-Nav-Draft-Preview-Mode';

type PcNavDraftPreviewParams = {
  isWeb: boolean;
  pathname: string | null | undefined;
  previewType: string | null | undefined;
};

/** 仅 PC 顶部导航的固定预览入口可以读取草稿导航。 */
export function isPcNavDraftPreview({
  isWeb,
  pathname,
  previewType,
}: PcNavDraftPreviewParams): boolean {
  return isWeb && pathname === HOME_PREVIEW_PATH && previewType === String(NAV_TYPE.WEB_HEADER);
}

/** 导航草稿仅用于固定预览入口；WAP 底部支持桌面后台直接打开。 */
export function getNavDraftPreviewMode({
  isWeb,
  pathname,
  previewType,
}: PcNavDraftPreviewParams): GlobalInitNavMode {
  if (isPcNavDraftPreview({ isWeb, pathname, previewType })) return 'pc-header-draft';
  if (pathname !== HOME_PREVIEW_PATH) return 'published';
  if (isWeb && previewType === String(NAV_TYPE.WEB_FOOTER)) return 'pc-footer-draft';
  if (previewType === String(NAV_TYPE.WAP_FOOTER)) return 'wap-footer-draft';
  return 'published';
}

/** 只覆盖桌面 WAP 底部预览的展示端，不改变真实设备识别、cookie 或 App 行为。 */
export function getNavPreviewDeviceType(
  deviceType: EPlatform,
  navMode: GlobalInitNavMode,
): EPlatform {
  return deviceType === EPlatform.WEB && navMode === 'wap-footer-draft'
    ? EPlatform.WAP
    : deviceType;
}
